<template>
  <div class="forgot-password-component-container">
    <form @submit.prevent="handleSubmit">
      <div class="heading">
        <img
          v-if="certApp"
          class="ase-logo"
          src="../../assets/images/ase/logo1.svg"
        >
        <img
          v-else
          :src="$store.getters['app/appLogo']"
        >
        <br>Forgot Your Password?
      </div>
      <p>Request a reset.</p>
      <div>
        <label
          class="title"
          for="email"
        >
          Email
        </label>
        <label
          v-if="invalid.email"
          class="error"
        >
          Invalid Email
        </label>
      </div>
      <input
        id="email"
        v-model="email"
        type="text"
      >
      <div class="bottom-container">
        <div class="error-container">
          <div
            v-if="message"
            class="error"
          >
            {{ message }}
          </div>
        </div>
        <button
          class="button"
          :class="{ loading : loading }"
        >
          {{ buttonText }}
        </button>
        <router-link
          :to="{ name: 'signIn' }"
        >
          Go back to Log in
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import Authentication from '@/mixins/authentication.js';

export default {
  mixins: [Authentication],
  data() {
    return {
      buttonText: 'Reset Password',
    };
  },
  created() {
    if (this.authenticated) {
      this.$router.push({name: 'home'});
    }
  },
  methods: {
    handleSubmit() {
      const valid = this.validateInput();

      if (!valid) return;

      this.loading = true;
      this.buttonText = 'Resetting Password...';
      this.$store.dispatch('session/resetPassword', { email: this.email }).then(response => {
        this.$router.push({ name: 'signIn' });

        this.$notify({
          group: 'notifications',
          text: 'Your password reset request has been sent, please check your email.',
          type: 'success',
        });
      }).catch(e => {
        this.message = 'An unexpected error occurred, please contact support.';
        setTimeout(() => { this.message = ''; }, 8000);
        this.buttonText = 'Reset Password';
        this.loading = false;
      });
    },
    validateInput() {
      if (!this.email || !/@.+\.\w+$/.test(this.email)) {
        this.addInvalid('email');
      } else {
        this.removeInvalid('email');
      }

      return !this.invalid.email;
    },
  },
};
</script>

<style lang='scss' scoped>
  $sign-in-modal-background: $white-1 !default;
  $sign-in-modal-suggestion: $grey-2 !default;
  $sign-in-modal-input-label: $grey-3 !default;
  $sign-in-modal-error-text: $red-1 !default;
  $sign-in-modal-button-background: $green-1 !default;
  $sign-in-modal-button-text: $white-1 !default;
  $sign-in-modal-title-text: $grey-2 !default;
  $sign-in-modal-input-border: $grey-4 !default;
  $sign-in-modal-input-error-border: $red-1 !default;
  $sign-in-modal-input-disabled: $grey-4 !default;

  .forgot-password-component-container {
    height: 100%;

    form {
      margin: 0 auto;
      max-width: rem-calc(400);

      label {
        &.title {
          color: $sign-in-modal-input-label;
          display: inline-block;
          font-weight: 600;
        }

        &.error {
          color: red;
          float: right;
          font-size: 12px;
        }
      }

      input {
        border: 1px solid $sign-in-modal-input-border;
        border-radius: 4px;
        box-sizing: border-box;
        margin: rem-calc(4) 0 rem-calc(12) 0;
        width: 100%;

        &.error {
          border-color: $sign-in-modal-input-error-border;
        }
      }

      p {
        text-align: center;
      }

      .heading {
        color: $sign-in-modal-title-text;
        @include font-size(28);
        font-weight: $semi-bold;
        margin-bottom: rem-calc(24);
        text-align: center;

        img {
          max-width: rem-calc(48);

          &.ase-logo {
            margin-bottom: rem-calc(16);
            max-width: rem-calc(96);
            width: 100%;
          }
        }
      }

      .error-container .error {
        color: $sign-in-modal-error-text;
        @include font-size(12);
        margin-bottom: rem-calc(4);
        text-align: center;
      }

      .button {
        display: block;
        border: none;
        width: 100%;
        background-color: $sign-in-modal-button-background;
        border-radius: 4px;
        color: $sign-in-modal-button-text;
        margin-bottom: rem-calc(12);
        padding: rem-calc(10);
        text-align: center;

        &:active {
          opacity: 0.8;
        }

        &.loading {
          pointer-events: none;
        }
      }

      .bottom-container {
        margin-top: auto;
        text-align: center;

        a {
          color: #354052;
          font-size: rem-calc(14);
          text-decoration: underline;
        }
      }
    }
  }
</style>
